<div class="feature-discovery">
  <gl-feature-discovery *ngIf="currentFeature" [target]="currentFeature.target" colorPrimary>
    <div class="feature-discovery__content" [innerHTML]="currentFeature.text"></div>
    <div class="feature-discovery__buttons">
      <gl-button color-secondary [text]="'actions.gotIt' | translate" (onClick)="setNextFeature()"></gl-button>
    </div>
  </gl-feature-discovery>
</div>
